module.exports = __webpack_public_path__ + "static/media/alchemix.a6ac4459.png";